import { render, staticRenderFns } from "./my-comments.vue?vue&type=template&id=12afc21e&scoped=true&"
import script from "./my-comments.vue?vue&type=script&lang=ts&"
export * from "./my-comments.vue?vue&type=script&lang=ts&"
import style0 from "./my-comments.vue?vue&type=style&index=0&id=12afc21e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afc21e",
  null
  
)

export default component.exports